import { ThemeProvider } from "styled-components";

const theme = {
  header: {
    color: "#080808",
  },
  subheader: {
    color: "#53575F",
  },
  card: {
    color: "#080808",
  },
  fonts: ["sans-serif", "Roboto"],
  fontSizes: {
    small: "1em",
    subheader: "2em",
    header: "3em",
  },
};

const Theme = (props: { children: React.ReactNode }) => (
  <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
);

export default Theme;
